import Home from '@/views/Home'

import LogIn from '@/modules/auth/views/LogIn'
import ExternalLogInRedirect from '@/modules/auth/views/ExternalLogInRedirect'
import Register from '@/modules/auth/views/Register'
import InvitationAcceptance from '@/modules/auth/views/InvitationAcceptance'
import CompleteRegistration from '@/modules/auth/views/CompleteRegistration'

import PickSupplier from '@/modules/pickSupplier/views/PickSupplier'

import Dashboard from '@/modules/dashboard/views/Dashboard'

import Account from '@/modules/account/views/Account'
import LoginSecurity from '@/modules/account/views/LoginSecurity'
import ManageDetails from '@/modules/account/views/ManageDetails'
import BankDetails from '@/modules/account/views/BankDetails'
import Subscription from '@/modules/account/views/Subscription'
import SubscriptionCreated from '@/modules/account/views/SubscriptionCreated'
import UsersManagement from '@/modules/account/views/UsersManagement'
import RetailerTurnInOrders from '@/modules/account/views/RetailerTurnInOrders'
import RetailerManagementForAgents from '@/modules/account/views/RetailerManagementForAgents'
import AgentInvitesManagement from '@/modules/account/views/AgentInvitesManagement'
import ApprovedAgentsByRetailer from '@/modules/account/views/ApprovedAgentsByRetailer'
import EmailPreferences from '@/modules/account/views/EmailPreferences'
import OrderChatHistory from '@/modules/account/views/OrderChatHistory'
import SupplierTradingAgreements from '@/modules/account/views/SupplierTradingAgreements'

import DataMaintenance from '@/modules/dataMaintenance/views/DataMaintenance'
import CreditReturnAvailability from '@/modules/dataMaintenance/views/CreditReturnAvailability.vue'
import TradingRules from '@/modules/dataMaintenance/views/TradingRules'
import ZonePostCode from '@/modules/dataMaintenance/views/ZonePostCode'
import UsTaxCodes from '@/modules/dataMaintenance/views/UsTaxCodes'
import BrandLogos from '@/modules/dataMaintenance/views/BrandLogos'
import Rebates from '@/modules/dataMaintenance/views/Rebates'
import PaymentDays from '@/modules/dataMaintenance/views/PaymentDays'
import PriceDrops from '@/modules/dataMaintenance/views/PriceDrops'
import Products from '@/modules/dataMaintenance/views/Products'
import ProductsBulkUpload from '@/modules/dataMaintenance/views/ProductsBulkUpload'
import Specials from '@/modules/dataMaintenance/views/Specials'
import MultiSpecialUpload from '@/modules/dataMaintenance/views/MultiSpecialUpload'
import VolumeBuys from '@/modules/dataMaintenance/views/VolumeBuys'
import BuyGetFree from '@/modules/dataMaintenance/views/BuyGetFree'
import Coupons from '@/modules/dataMaintenance/views/Coupons'
import FamilyGroups from '@/modules/dataMaintenance/views/FamilyGroups'
import MultiVolumeBuyUpload from '@/modules/dataMaintenance/views/MultiVolumeBuyUpload'

import PurchaseOrders from '@/modules/purchaseOrders/views/PurchaseOrders'
import PurchaseOrderDetails from '@/modules/purchaseOrders/views/PurchaseOrderDetails'

import OrderQueries from '@/modules/orderQueries/views/OrderQueries'
import OrderQueryDetails from '@/modules/orderQueries/views/OrderQueryDetails'

import CreditReturns from '@/modules/creditReturns/views/CreditReturns'
import CreditReturnDetails from '@/modules/creditReturns/views/CreditReturnDetails'

import UserGuide from '@/modules/userGuide/views/UserGuide'

import Reports from '@/modules/reports/views/Reports'
import Forecast from '@/modules/reports/views/Forecast'
import SalesMetrics from '@/modules/reports/views/SalesMetrics'
import SalesByProducts from '@/modules/reports/views/SalesByProducts'
import SalesByRetailers from '@/modules/reports/views/SalesByRetailers'
import PurchaseOrdersHistory from '@/modules/reports/views/PurchaseOrdersHistory'
import OrderQueriesHistory from '@/modules/reports/views/OrderQueriesHistory'
import CreditReturnsHistory from '@/modules/reports/views/CreditReturnsHistory'
import PaymentAdjustmentsHistory from '@/modules/reports/views/PaymentAdjustmentsHistory'
import PaymentAdjustmentDetails from '@/modules/reports/views/PaymentAdjustmentDetails'
import PaymentTransactions from '@/modules/reports/views/PaymentTransactions'
import Transactions from '@/modules/reports/views/Transactions'
import Fees from '@/modules/reports/views/Fees'

import PrivacyPolicy from '@/modules/footer/views/PrivacyPolicy'
import TermsConditions from '@/modules/footer/views/TermsConditions'

const accessControlTypes = {
  tradingBlocker: 'tradingBlocker',
  subscriptionBlocker: 'subscriptionBlocker',
  roleBlocker: 'roleBlocker',
  creditReturnsBlocker: 'creditReturnsBlocker',
  supplierDirectPaymentTypeBlocker: 'supplierDirectPaymentTypeBlocker',
  paymentServicesPaymentTypeBlocker: 'paymentServicesPaymentTypeBlocker'
}

const routes = [
  {
    path: '/login-redirect',
    name: 'login-redirect',
    component: ExternalLogInRedirect,
    meta: {
      noauth: true
    }
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: 'Dashboard' },
    redirect: { name: 'dashboard' },
    children: [
      // MAIN VIEW
      {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
          title: 'Dashboard',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      // AUTH VIEWS
      {
        path: '/account/login',
        name: 'login',
        component: LogIn,
        meta: {
          noauth: true,
          hideMenu: true,
          hideSubMenu: true,
          hideTerms: true,
          title: 'Login',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/account/register',
        name: 'register',
        component: Register,
        meta: {
          noauth: true,
          hideMenu: true,
          hideSubMenu: true,
          hideTerms: true,
          title: 'Register',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/invitation',
        name: 'invitation',
        component: InvitationAcceptance,
        meta: {
          noauth: true,
          hideMenu: true,
          hideSubMenu: true,
          hideTerms: true,
          title: 'Invitation Acceptance',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/complete-registration',
        name: 'complete-registration',
        component: CompleteRegistration,
        meta: {
          noauth: true,
          hideMenu: true,
          hideSubMenu: true,
          hideTerms: true,
          title: 'Complete Registration',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      // PICK SUPPLIER VIEWS
      {
        path: '/pick-supplier',
        name: 'pick-supplier',
        component: PickSupplier,
        meta: {
          hideMenu: true,
          hideSubMenu: true,
          hideTerms: true,
          title: 'Pick Supplier',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      // ACCOUNT MANAGEMENT VIEWS
      {
        path: '/account',
        name: 'account',
        component: Account,
        meta: {
          title: 'My Account',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/account/login-security',
        name: 'login-security',
        component: LoginSecurity,
        meta: {
          title: 'Login & Security',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            { text: 'Login & Security', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/account/manage-details',
        name: 'manage-details',
        component: ManageDetails,
        meta: {
          title: 'Manage Details',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            { text: 'Manage Details', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/account/subscription',
        name: 'subscription',
        component: Subscription,
        meta: {
          title: 'Subscription Management',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            { text: 'Subscription Management', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/account/subscription-created',
        name: 'subscription-created',
        component: SubscriptionCreated,
        meta: {
          title: 'Subscription Created',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            { text: 'Subscription Created', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/account/bank-details',
        name: 'bank-details',
        component: BankDetails,
        meta: {
          title: 'Bank Details',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            { text: 'Bank Details', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/account/users-management',
        name: 'users-management',
        component: UsersManagement,
        meta: {
          title: 'Multiple Account Users',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            { text: 'Multiple Account Users', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/account/retailer-turn-in-orders',
        name: 'retailer-turn-in-orders',
        component: RetailerTurnInOrders,
        meta: {
          title: 'Retailer Turn In Orders',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            { text: 'Retailer Turn In Orders', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: 'account/retailer-turn-in-orders/retailers',
        name: 'retailer-management-for-agents',
        component: RetailerManagementForAgents,
        meta: {
          title: 'Retailer Management for Agents',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            {
              text: 'Retailer Turn In Orders',
              exact: true,
              to: { name: 'retailer-turn-in-orders' }
            },
            { text: 'Retailer Management for Agents', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        },
        props: (route) => ({
          status: route.query.status
        })
      },
      {
        path: 'account/retailer-turn-in-orders/agent-invites',
        name: 'agent-invites-management',
        component: AgentInvitesManagement,
        meta: {
          title: 'Agent Invites & Management',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            {
              text: 'Retailer Turn In Orders',
              exact: true,
              to: { name: 'retailer-turn-in-orders' }
            },
            { text: 'Agent Invites & Management', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: 'account/retailer-turn-in-orders/approved-agents',
        name: 'approved-agents-by-retailer',
        component: ApprovedAgentsByRetailer,
        meta: {
          title: 'Approved Agents by Retailers',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            {
              text: 'Retailer Turn In Orders',
              exact: true,
              to: { name: 'retailer-turn-in-orders' }
            },
            { text: 'Approved Agents by Retailers', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/account/email-preferences',
        name: 'email-preferences',
        component: EmailPreferences,
        meta: {
          title: 'Email Preferences',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            { text: 'Email Preferences', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/account/order-chat-history',
        name: 'order-chat-history',
        component: OrderChatHistory,
        meta: {
          title: 'Order Message History',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            { text: 'Order Message History', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/account/supplier-trading-agreements',
        name: 'supplier-trading-agreements',
        component: SupplierTradingAgreements,
        meta: {
          title: 'Trading Agreements',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            { text: 'Trading Agreements', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/account/user-agreement',
        name: 'supplier-user-agreement',
        component: SupplierTradingAgreements,
        meta: {
          title: 'User Agreement',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'My Account', exact: true, to: { name: 'account' } },
            { text: 'User Agreement', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      // APP VIEWS
      {
        path: '/user-guide',
        name: 'user-guide',
        component: UserGuide,
        meta: {
          title: 'User Guide',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'User Guide', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      // DATA MAINTENANCE VIEWS
      {
        path: '/data-maintenance',
        name: 'data-maintenance',
        component: DataMaintenance,
        meta: {
          title: 'Data Setup & Maintenance',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Data Setup & Maintenance', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/data-maintenance/products',
        name: 'products',
        component: Products,
        meta: {
          title: 'Range & Pricing Details',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Range & Pricing Details', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        },
        props: (route) => ({
          supplierItemId: route.query.supplierItemId?.toString(),
          status: route.query.status
        })
      },
      {
        path: '/data-maintenance/products/bulk-upload',
        name: 'products-bulk-upload',
        redirect: { name: 'products-import' }
      },
      {
        path: '/data-maintenance/products/import',
        name: 'products-import',
        component: ProductsBulkUpload,
        props: { mode: 'import' },
        meta: {
          title: 'Import Products',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            {
              text: 'Range & Pricing Details',
              exact: true,
              to: { name: 'products' }
            },
            { text: 'Import Products', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/data-maintenance/products/update-prices',
        name: 'products-price-update',
        component: ProductsBulkUpload,
        props: { mode: 'price-update' },
        meta: {
          title: 'Update Prices',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            {
              text: 'Range & Pricing Details',
              exact: true,
              to: { name: 'products' }
            },
            { text: 'Update Prices', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/data-maintenance/trading-rules',
        name: 'trading-rules',
        component: TradingRules,
        meta: {
          title: 'Supplier Trading Rules Management',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Supplier Trading Rules Management', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/data-maintenance/zone-postcode',
        name: 'zone-postcode',
        component: ZonePostCode,
        meta: {
          title: 'Zone Postcode Details',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Zone Postcode Details', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/data-maintenance/us-tax-codes',
        name: 'us-tax-codes',
        component: UsTaxCodes,
        meta: {
          title: 'Tax Viewer (US TIC)',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Tax Viewer (US TIC)', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/data-maintenance/brand-logos',
        name: 'brand-logos',
        component: BrandLogos,
        meta: {
          title: 'Supplier & Brand Logos',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Supplier & Brand Logos', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/data-maintenance/family-groups',
        name: 'family-groups',
        component: FamilyGroups,
        meta: {
          title: 'Family Groups',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Family Groups', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        },
        props: (route) => ({
          familyGroupId: route.query.familyGroupId?.toString()
        })
      },
      {
        path: '/data-maintenance/price-drops',
        name: 'price-drops',
        component: PriceDrops,
        meta: {
          title: 'Price Drops',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Price Drops', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        },
        props: (route) => ({
          id: route.query.id?.toString()
        })
      },
      {
        path: '/data-maintenance/specials',
        name: 'specials',
        component: Specials,
        meta: {
          title: 'Specials',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Specials', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        },
        props: (route) => ({
          id: route.query.id?.toString(),
          status: route.query.status
        })
      },
      {
        path: '/data-maintenance/specials/multi-upload',
        name: 'specials-multi-upload',
        component: MultiSpecialUpload,
        meta: {
          title: 'Add Multiple Specials',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Specials', exact: true, to: { name: 'specials' } },
            { text: 'Add Multiple Specials', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/data-maintenance/volume-buys',
        name: 'volume-buys',
        component: VolumeBuys,
        meta: {
          title: 'Volume Buys',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Volume Buys', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        },
        props: (route) => ({
          id: route.query.id?.toString(),
          status: route.query.status
        })
      },
      {
        path: '/data-maintenance/buy-get-free',
        name: 'buy-get-free',
        component: BuyGetFree,
        meta: {
          title: 'Buy Get Free',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Buy Get Free', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        },
        props: (route) => ({
          id: route.query.id?.toString(),
          status: route.query.status
        })
      },
      {
        path: '/data-maintenance/volume-buys/multi-upload',
        name: 'volume-buys-multi-upload',
        component: MultiVolumeBuyUpload,
        meta: {
          title: 'Add Multiple Volume Buys',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Volume Buys', exact: true, to: { name: 'volume-buys' } },
            { text: 'Add Multiple Volume Buys', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/data-maintenance/coupons',
        name: 'coupons',
        component: Coupons,
        meta: {
          title: 'Coupons',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Coupons', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/data-maintenance/credit-returns',
        name: 'credit-return-availability',
        component: CreditReturnAvailability,
        meta: {
          title: 'Credit Returns',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Credit Returns', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker
          ]
        }
      },
      {
        path: '/data-maintenance/rebates',
        name: 'rebates',
        component: Rebates,
        meta: {
          title: 'Rebates',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Rebates', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/data-maintenance/payment-days',
        name: 'payment-days',
        component: PaymentDays,
        meta: {
          title: 'Payment Days',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            {
              text: 'Data Setup & Maintenance',
              exact: true,
              to: { name: 'data-maintenance' }
            },
            { text: 'Payment Days', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker,
            accessControlTypes.supplierDirectPaymentTypeBlocker
          ]
        }
      },
      // PURCHASE ORDERS VIEWS
      {
        path: '/purchase-orders',
        name: 'purchase-orders',
        component: PurchaseOrders,
        meta: {
          title: 'Purchase Orders',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Purchase Orders', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        },
        props: (route) => ({
          status: route.query.status
        })
      },
      {
        path: '/purchase-orders/:id',
        name: 'purchase-order-details',
        component: PurchaseOrderDetails,
        meta: {
          title: 'Purchase Order Details',
          // breadcrumbs in page as required computation
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        },
        props: (route) => ({
          orderId: route.params.id?.toString()
        })
      },
      // ORDER QUERIES VIEWS
      {
        path: '/order-queries',
        name: 'order-queries',
        component: OrderQueries,
        meta: {
          title: 'Order Queries',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Order Queries', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/order-queries/:id',
        name: 'order-query-details',
        component: OrderQueryDetails,
        meta: {
          title: 'Order Query Details',
          // breadcrumbs in page as required computation
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        },
        props: (route) => ({
          queryId: route.params.id?.toString()
        })
      },
      // CREDIT RETURNS VIEWS
      {
        path: '/credit-returns',
        name: 'credit-returns',
        component: CreditReturns,
        meta: {
          title: 'Credit Returns',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Credit Returns', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker
          ]
        }
      },
      {
        path: '/credit-returns/:id',
        name: 'credit-return-details',
        component: CreditReturnDetails,
        meta: {
          title: 'Credit Return Details',
          // breadcrumbs in page as required computation
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker
          ]
        },
        props: (route) => ({
          creditReturnId: route.params.id?.toString()
        })
      },
      // REPORT VIEWS
      {
        path: '/reports',
        name: 'reports',
        component: Reports,
        meta: {
          title: 'Reports',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/reports/forecast',
        name: 'forecast-report',
        component: Forecast,
        meta: {
          title: 'Forecast',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', exact: true, to: { name: 'reports' } },
            { text: 'Forecast', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/reports/sales-metrics',
        name: 'sales-metrics',
        component: SalesMetrics,
        meta: {
          title: 'Sales Metrics',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', exact: true, to: { name: 'reports' } },
            { text: 'Sales Metrics', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/reports/sales-by-products',
        name: 'sales-by-products',
        component: SalesByProducts,
        meta: {
          title: 'Sales By Products',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', exact: true, to: { name: 'reports' } },
            { text: 'Sales By Products', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/reports/sales-by-retailers',
        name: 'sales-by-retailers',
        component: SalesByRetailers,
        meta: {
          title: 'Sales By Retailers',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', exact: true, to: { name: 'reports' } },
            { text: 'Sales By Retailers', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/reports/purchase-orders-history',
        name: 'purchase-orders-history',
        component: PurchaseOrdersHistory,
        meta: {
          title: 'Purchase Orders History',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', exact: true, to: { name: 'reports' } },
            { text: 'Purchase Orders History', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/reports/order-queries-history',
        name: 'order-queries-history',
        component: OrderQueriesHistory,
        meta: {
          title: 'Order Queries History',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', exact: true, to: { name: 'reports' } },
            { text: 'Order Queries History', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/reports/credit-returns-history',
        name: 'credit-returns-history',
        component: CreditReturnsHistory,
        meta: {
          title: 'Credit Returns History',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', exact: true, to: { name: 'reports' } },
            { text: 'Credit Returns History', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker
          ]
        }
      },
      {
        path: '/reports/payment-adjustments',
        name: 'payment-adjustments',
        component: PaymentAdjustmentsHistory,
        meta: {
          title: 'Payment Adjustments',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', exact: true, to: { name: 'reports' } },
            { text: 'Payment Adjustments', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/reports/payment-adjustments/:paymentAdjustmentId',
        name: 'payment-adjustment-details',
        meta: {
          title: 'Payment Adjustment Details',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', exact: true, to: { name: 'reports' } },
            {
              text: 'Payment Adjustments',
              exact: true,
              to: { name: 'payment-adjustments' }
            }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        },
        component: PaymentAdjustmentDetails,
        props: (route) => ({
          paymentAdjustmentId: route.params.paymentAdjustmentId?.toString()
        })
      },
      {
        path: '/reports/transactions',
        name: 'transactions',
        component: Transactions,
        meta: {
          title: 'Transactions',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', exact: true, to: { name: 'reports' } },
            { text: 'Transactions', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/reports/payment-transactions',
        name: 'payment-transactions',
        component: PaymentTransactions,
        meta: {
          title: 'Payment Services',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', exact: true, to: { name: 'reports' } },
            { text: 'Payment Services', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker,
            accessControlTypes.paymentServicesPaymentTypeBlocker
          ],
          paymentType: 'PAYMENT_SERVICES'
        }
      },
      {
        path: '/reports/card-transactions',
        name: 'card-transactions',
        component: PaymentTransactions,
        meta: {
          title: 'Card Services',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', exact: true, to: { name: 'reports' } },
            { text: 'Card Services', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker,
            accessControlTypes.creditCardPaymentTypeBlocker
          ],
          paymentType: 'CREDIT_CARD'
        }
      },
      {
        path: '/reports/fees',
        name: 'fees',
        component: Fees,
        meta: {
          title: 'Fees',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Reports', exact: true, to: { name: 'reports' } },
            { text: 'Fees', to: null }
          ],
          class: 'g-container-large',
          enabledAccessFor: [
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },

      // FOOTER VIEWS
      {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: PrivacyPolicy,
        meta: {
          noauth: true,
          hideMenu: true,
          hideSubMenu: true,
          title: 'Privacy Policy',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Privacy Policy', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      },
      {
        path: '/terms-conditions',
        name: 'terms-conditions',
        component: TermsConditions,
        meta: {
          noauth: true,
          hideMenu: true,
          hideSubMenu: true,
          title: 'Terms & Conditions',
          breadcrumbs: [
            { text: 'Home', exact: true, to: { name: 'dashboard' } },
            { text: 'Terms & Conditions', to: null }
          ],
          class: 'g-container',
          enabledAccessFor: [
            accessControlTypes.tradingBlocker,
            accessControlTypes.subscriptionBlocker,
            accessControlTypes.roleBlocker,
            accessControlTypes.creditReturnsBlocker
          ]
        }
      }
    ]
  }
]

export default routes
